import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles } from "lucide-react";

// Public homepage social-proof counter. Renders NOTHING unless an admin has
// enabled it. The number is always supplied by the backend from genuine data.
export function SocialProofCounter() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/social-proof").then((r) => setData(r.data)).catch(() => setData({ enabled: false }));
  }, []);

  if (!data || !data.enabled) return null;

  return (
    <section data-testid="social-proof-counter" className="border-y border-emerald-100 bg-emerald-50/50">
      <div className="mx-auto flex max-w-4xl flex-col items-center px-4 py-10 text-center sm:py-14">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-white px-3 py-1 text-xs font-semibold uppercase tracking-wider text-emerald-700">
          <Sparkles className="h-3.5 w-3.5" /> Nearfluence impact
        </span>
        <p data-testid="social-proof-value" className="mt-4 font-display text-5xl font-extrabold tracking-tight text-emerald-600 sm:text-6xl">
          {data.display}
        </p>
        {data.headline && (
          <p data-testid="social-proof-headline" className="mt-3 max-w-xl text-base text-zinc-600">
            {data.headline}
          </p>
        )}
      </div>
    </section>
  );
}
